export type DashboardsV2ApiResponse = /** status 200  */ DashboardsV2ResponseBody;
export type DashboardsV2ApiArg = void;
export type DashboardV2ResponseBody = {
  identifier: string;
  title: string;
};
export type DashboardsV2ResponseBody = {
  expiresAt: string;
  token: string;
  domain: string;
  workspaceId: string;
  dashboards: DashboardV2ResponseBody[];
};
